import classnames from 'classnames'
import { FunctionalComponent, h } from 'preact'

type ChipComponent = 'a' | 'button' | 'span'
export interface ChipProps extends Omit<JSX.HTMLAttributes, 'size'> {
  variant?: 'squared' | 'rounded'
  size?: 'medium' | 'small'
  active?: boolean
  startIcon?: JSX.Element
  endIcon?: JSX.Element
  component?: ChipComponent
}

export const Chip: FunctionalComponent<ChipProps> = (props) => {
  const {
    variant = 'rounded',
    size = 'medium',
    children,
    active,
    startIcon,
    endIcon,
    className,
    href,
    onClick,
    component,
    ...restProps
  } = props
  const Component = getChipComponent(props)
  return (
    <Component
      {...restProps}
      onClick={onClick}
      href={href}
      className={classnames(
        'chip',
        className,
        `chip--size-${size}`,
        `chip--variant-${variant}`,
        {
          'chip--active': active,
          'chip--interactive': onClick || href
        }
      )}
    >
      {startIcon && <span className='chip-icon--start'>{startIcon}</span>}
      <span className='chip-label'>{children}</span>
      {endIcon && <span className='chip-icon--end'>{endIcon}</span>}
    </Component>
  )
}

export default Chip

const getChipComponent = (props: ChipProps): ChipComponent => {
  const { component, href, onClick } = props
  if (component) {
    // the case when component prop is passed manually
    return component
  }
  if (href) {
    return 'a'
  }
  if (onClick) {
    return 'button'
  }
  return 'span'
}
